export default __webpack_public_path__ + "static/media/spr-storyboarder-light-large.debe399b.png";